export default class GtmService {
    [x: string]: any;

    constructor() {
        if (! Object.hasOwnProperty.call(window, 'dataLayer')) {
            console.error('`window.dataLayer` is not defined.');
        }
    }

    push(data) {
        window['dataLayer'].push({event: data});
    }
}
